import type { ProcessDefinitionList } from '@/api/chat';
import icon from '@/assets/images/dark-icon-agent@2x.png';
import styles from '../../index.module.scss';

type DisplayProcess = ProcessDefinitionList & { name?: string };

interface DefaultHomeProps {
  processInfo?: DisplayProcess;
  processList?: DisplayProcess[];
  onSelect: (process: DisplayProcess) => void;
  onRecommendedQuestionSelect: (question: string) => void;
}

const DefaultHome = ({ processInfo, processList, onSelect, onRecommendedQuestionSelect }: DefaultHomeProps) => {
  const recommendedQuestions = processInfo?.recommendedQuestions?.filter(question => question.trim()).slice(0, 10);

  return (
    <>
      <div className={styles.homeTitle}>
        欢迎使用
        <span className={styles.title}>{processInfo?.agentName || '智慧能源助手'}</span>
      </div>
      <div className={styles.desc}>{processInfo?.agentDescription}</div>
      <div className={styles.card}>
        {processList?.map(item => {
          const itemName = item.agentName || item.name;

          return (
            <div
              key={item.id}
              className={`${styles.cardItem} ${processInfo?.id === item.id ? styles.selectedCardItem : ''}`}
              onClick={() => onSelect(item)}
            >
              <div className={styles.cardTitle} title={itemName}>
                <img src={icon} width={16} style={{ marginTop: 2 }} />
                <span className={styles.cardTitleText}>{itemName}</span>
              </div>
              <div className={styles.cardDesc}>{processInfo?.id === item.id ? '当前智能体' : ''}</div>
              <div className={styles.hoverDesc} title={item.agentDescription}>
                <span>{item.agentDescription}</span>
              </div>
            </div>
          );
        })}
      </div>
      {recommendedQuestions?.length ? (
        <div className={styles.homeRecommended}>
          <div className={styles.homeRecommendedTitle}>你可能想知道：</div>
          <div className={styles.homeRecommendedList}>
            {recommendedQuestions.map((question, index) => (
              <span
                key={`${question}-${index}`}
                className={styles.homeRecommendedQuestion}
                onClick={() => onRecommendedQuestionSelect(question)}
              >
                {question}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DefaultHome;
